// Userinfo.jsx — entry point
// Just configure QUESTIONS and WELCOME_CONFIG, everything else is automatic.

import React, { Fragment } from "react";
import HealthStepper from "../components/Reusablesteps/Healthstepper";
import styles from "./Userinfo.module.css";
import { Globalimages } from "../components/Imagesreusable";

/* ─────────────────────────────────────────────────────────────────────
   WELCOME CONFIG
───────────────────────────────────────────────────────────────────── */
const WELCOME_CONFIG = {
  title: "Hi 👋 I’m your symptom checker assistant.",
  subtitle: "Let's get to know you better (takes 20 seconds)",
  buttonText: "Let's start",
  skipLabel: "Skip to Home",
};

/* ─────────────────────────────────────────────────────────────────────
   QUESTIONS ARRAY
   Each object = one full screen / one question.
   type: "chips" | "slider" | "text" | "number" | "contact"
───────────────────────────────────────────────────────────────────── */
const QUESTIONS = [
  {
    id: "age_group",
    question: "What's your age group?",
    description: "This helps us personalize your experience",
    type: "chips",
    info: true,
    // options: ["18–25", "26–35", "36–45", "46–55", "56+"],
    options: [
      { label: "18–25", value: "18–25", icon: Globalimages.image1 },
      { label: "26–35", value: "26–35", icon: Globalimages.image2 },
      { label: "36–45", value: "36–45", icon: Globalimages.image3 },
      { label: "46–55", value: "46–55", icon: Globalimages.image4 },
      { label: "56+", value: "56+", icon: Globalimages.image5 },
    ],
    summaryLabel: "Age Group",
    summaryIcon: "🎂",
  },
  {
    id: "daily_routine",
    info: true,
    description: "This helps us personalize your experience",
    question: "Nice 👍 What best describes your daily routine?",
    type: "chips",
    // options: ["Working", "Homemaker", "Student"],
    options: [
      { label: "Working", value: "Working", icon: Globalimages.image10 },
      { label: "Homemaker", value: "Homemaker", icon: Globalimages.image11 },
      { label: "Student", value: "Student", icon: Globalimages.image12 },
    ],
    summaryLabel: "Lifestyle",
    summaryIcon: "🏢",
  },
  {
    id: "marital_status",
    info: true,
    description: "This helps us personalize your experience",
    question: "If you're comfortable sharing,",
     text: " what's your marital status?",
    type: "chips",
    // options: ["Single", "Married", "Divorced", "Prefer not to say"],
    options: [
      { label: "Single", value: "Single", icon: Globalimages.image6},
      { label: "Married", value: "Married", icon: Globalimages.image7},
      { label: "Divorced", value: "Divorced", icon:Globalimages.image8},
      { label: "Prefer not to say", value: "Prefer not to say", icon: Globalimages.image9 },
    ],
    summaryLabel: "Marital Status",
    summaryIcon: "💍",

  },
  {
    id: "height",
    question: "Let's personalise your experience📐",
    description: "This helps us personalize your experience",
    text: "What's your height?",
    type: "slider",
    sliderLabel: "Height",
    sliderMin: 3,
    sliderMax: 7,
    sliderStep: 0.1,
    sliderDefault: 5.3,
    sliderUnit: "Ft.",
    sliderDecimals: 1,
    sliderTicks: ["3", "4", "5", "6", "7"],
    summaryLabel: "Height",
    summaryIcon: "📏",
  },
  {
    id: "weight",
    question: "And your weight?",
    type: "slider",
    sliderLabel: "Weight",
    sliderMin: 30,
    sliderMax: 150,
    sliderStep: 1,
    sliderDefault: 58,
    sliderUnit: "Kg",
    sliderDecimals: 0,
    sliderTicks: ["30", "60", "90", "120", "150"],
    summaryLabel: "Weight",
    summaryIcon: "⚖️",
  },
];

/* ─────────────────────────────────────────────────────────────────────
   Userinfo
───────────────────────────────────────────────────────────────────── */
const SymptomChecker = () => {
  const handleComplete = ({ formAnswers }) => {
    console.log("✅ Submitted:", formAnswers);
    // TODO: POST formAnswers to your API
  };

  const handleSkip = () => {
    console.log("⏭ Skipped");
    // TODO: navigate("/home")
  };

  return (
    <Fragment>
       <div className={styles.page}>
      <HealthStepper
        confirmLink="/symptoms"
        welcome={WELCOME_CONFIG}
        questions={QUESTIONS}
        onComplete={handleComplete}
        onSkip={handleSkip}
      />
      </div>
    </Fragment>
  );
};

export default SymptomChecker;